<template>
    <!-- begin panel -->
    <panel :title="nuevo ? 'Registrar Nuevo Personal':'Editar Personal'" panelClass="panel-with-tabs"
        variant="default" ref="header" noButton="false">
        <form action="/" method="POST">
            <fieldset>
                <div class="row">
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Apellido Paterno</label>
                            <input type="text" data-vv-name="paterno" v-validate="'required'" v-model="personal.appa" placeholder="Ingrese el apellido paterno"
                                class="form-control">
                                 <error :attribute_name="'paterno'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Apellido Materno</label>
                            <input type="text" data-vv-name="materno" v-validate="'required'" v-model="personal.apma" placeholder="Ingrese el apellido materno"
                                class="form-control">
                                 <error :attribute_name="'materno'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Nombres</label>
                            <input type="text" data-vv-name="nombres" v-validate="'required'" v-model="personal.nombres" placeholder="Ingrese el nombre"
                                class="form-control">
                                 <error :attribute_name="'nombres'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div v-if="nuevo" class="form-group">
                            <label>DNI</label>
                            <input type="text" data-vv-name="dni" maxlength="8" v-validate="'required|numeric'" v-model="personal.dni" placeholder="Ingrese el dni"
                                class="form-control">
                                 <error :attribute_name="'dni'" :errors_form="errors" />
                        </div>
                        <div v-else class="form-group">
                            <label>Clave</label>
                            <input type="text" data-vv-name="clave"  v-validate="'required'" v-model="personal.clave" placeholder="Ingrese su clave"
                                class="form-control">
                                 <error :attribute_name="'clave'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Celular</label>
                            <input type="text" data-vv-name="celular" maxlength="9" v-validate="'required|numeric'" v-model="personal.cel" placeholder="Ingrese el # de celular"
                                class="form-control">
                                 <error :attribute_name="'celular'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Domicilio</label>
                            <input type="text" data-vv-name="domicilio" v-validate="'required'" v-model="personal.domicilio" placeholder="Ingrese el domicilio"
                                class="form-control">
                                 <error :attribute_name="'domicilio'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Correo Electrónico</label>
                            <input type="text" data-vv-name="correo"  maxlength="40"  v-validate="'required|email'" v-model="personal.email" placeholder="Ingrese el correo"
                                class="form-control">
                                 <error :attribute_name="'correo'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Tipo Vendedor</label>
                            <!-- <select  v-model="personal.tipo_vendedor"  data-vv-name="tipo" v-validate="'required'"  class="form-control">
                                <option value="">Seleccione...</option>
                                <option value="1">FFVV</option>
                                <option value="2">PDV</option>

                            </select> -->
                            <selecTipoPersonal  
                              :valor_entrada="personal.tipo_vendedor" 
                            v-model="personal.tipo_vendedor" 
                             data-vv-name="tipo" 
                             v-validate="'required'" 
                               @evento="personal.tipo_vendedor=$event" />
                                 <error :attribute_name="'tipo'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Departamento</label>
                            
                            <departamento 
                            :valor_entrada="personal.id_depa" 
                            @evento="personal.id_depa=$event" 
                            v-model="personal.id_depa" 
                            data-vv-name="departamento" 
                            v-validate="'required'"/>
                                 <error :attribute_name="'departamento'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Cargo</label>
                            <select v-model="personal.tipo"   data-vv-name="cargo" v-validate="'required'" class="form-control">
                                <option value="">Seleccione</option>
                                  <option value="2">Administrador (Principal)</option>
                                <option value="1">Vendedor</option>
                                <option value="3">Responsable FFVV</option>
                                <option value="4">Responsable PDV</option>
                                <option value="5">Responsable AACC </option>
                                <option value="6">Responsable VVMM </option>
                                <option value="7">Responsable MMARCA </option>
                            </select>
                            <error :attribute_name="'cargo'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Equipo</label>
                            <input type="text" v-model="personal.equipo" maxlength="50"  class="form-control">
                            
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-4">
                        <div class="form-group">
                            <label>Observaciones</label>
                            <textarea v-model="personal.observaciones" rows="4" class="form-control"></textarea>

                        </div>
                    </div>
                   
                </div>
                <hr>
                <div class="row">
                    <div class=" offset-xl-8 offset-lg-8  offset-md-8 col-xl-2  col-lg-2  col-md-2 text-center">
                        <button type="button" @click="$emit('cancelar')" class="btn btn-default btn-sm btn-circle  btn-block"> <i
                                class="fa fa-times "></i> CANCELAR </button>
                    </div>
                    <div class="  col-xl-2 col-lg-2 col-md-2  text-center">
                        <button v-if="nuevo" type="button" @click="validarFormulario('guardar')"
                            class="btn btn-primary btn-sm btn-circle btn-block"> <i class="fa fa-save "></i> GUARDAR </button>
                        <button v-else type="button" @click="validarFormulario('actualizar')"
                            class="btn btn-info btn-sm btn-circle  btn-block"> <i class="fa fa-save "></i> EDITAR </button>
                    </div>

                </div>

            </fieldset>
        </form>

    </panel>
    <!-- end panel -->
</template>

<script>
    import autocompletado from '../Autocomplete'
    import departamento from '../SelectDepartamentos.vue'
    import error from '../Error'
    import selecTipoPersonal from '../SelectTipoVendedor.vue'

    export default {
        name: 'PersonalComponent',
        props: ['registro', 'nuevo'],
        components: {
            autocompletado,
            error,
            departamento,
            selecTipoPersonal
            // vueSelect
        },
        data() {
            return {
                data: [],
                iniciar_autocompletado: false,
                personal: {
                    idpersona:"",
                    appa: "",
                    apma: "",
                    nombres: "",
                    equipo:"",
                    observaciones:"",
                    dni: "",
                    clave:"",
                    celular: "",
                    domicilio: "",
                    email: "",
                    tipo:"",
                    tipo_vendedor:"",
                    id_depa:""
                },
            }
        },
        created() {
            setTimeout(() => {
                this.iniciar_autocompletado = true;
            }, 100);

        },
        mounted() {
            if (!this.nuevo) {
                this.personal = {
                    ...this.registro
                };
            } else {
                this.limpiar();
            }
            this.data = this.$store.state.dataTipoAfectacion;
        },
        methods: {
            validarFormulario(tipo){

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if(tipo=='guardar'){
                            this.$emit('guardar',this.personal);
                        }else{
                            this.$emit('actualizar',this.personal);
                            setTimeout(() => {
                                this.$emit('cancelar');
                            }, 250);
                            
                        }
                        return;
                    }
                });
            },
            opcionSeleccionada(seleccion) {
                this.personal.emisor_id = seleccion.id;
            },
            limpiar() {
                this.personal.personal = "";
                this.personal.emisor_id = "";
                this.personal.emisor = "";
                this.personal.estado = "1";
            },

        }
    }
</script>